import { PropTypes } from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Button } from 'reactstrap';
import { compose } from 'redux';
import tabletFinger from '../../../images/tablet_finger.svg';

const ClaimAddedConfirmation = ({ history, match, intl }) => {
  const { site, claim } = match.params;

  return (
    <div className="container-fluid">
      <section
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '60vh',
        }}
      >
        <div style={{ textAlign: 'center', maxWidth: 400 }}>
          <img src={tabletFinger} alt="Tablet" style={{ width: 160, marginBottom: 24 }} />
          <h1>{intl.formatMessage({ id: 'thankYou' })}</h1>
          <p style={{ marginBottom: 24 }}>{intl.formatMessage({ id: 'returnTablet' })}</p>
          <button
            className="button primary"
            onClick={() => {
              history.push(`/${site}/claims-old/${claim}/edit`);
            }}
          >
            {intl.formatMessage({ id: 'continue' })}
          </button>
        </div>
      </section>
    </div>
  );
};

ClaimAddedConfirmation.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      site: PropTypes.string.isRequired,
      claim: PropTypes.string.isRequired,
    }).isRequired,
  }),
  intl: PropTypes.shape({}).isRequired,
};

export default compose(withRouter, injectIntl)(ClaimAddedConfirmation);
